import { render, staticRenderFns } from "./ProductRecordFormer.vue?vue&type=template&id=c74595e4&"
import script from "./ProductRecordFormer.vue?vue&type=script&lang=js&"
export * from "./ProductRecordFormer.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecordFormer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports